import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'section-loader',
  templateUrl: './section-loader.component.html',
  styleUrls: ['./section-loader.component.scss']
})
export class SectionLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
